<template>
    <b-row align-v="end" class="address-settings">
        <b-col md="8" v-if="options.length > 0">
            <label class="mb-2">{{label ? label : 'Addresses'}}</label>
            <v-select :disabled="disabled"
                      class="bg-white"
                      :options="options"
                      :searchable="false"
                      :closeOnSelect="true"
                      :filterable="false"
                      :clearable="false"
                      max-height="300px"
                      @input="$emit('changedAddress', selected)"
                      label="label"
                      v-model="selected">
                <template slot="option" slot-scope="option">
                    <div class="row">
                        <div class="col-md-6">
                            <h6><b>Full name:</b> {{option.label.fullName}}</h6>
                            <h6><b>Phone:</b> {{option.label.phone}}</h6>
                            <h6><b>Country:</b> {{option.label.country}}</h6>
                            <h6><b>Country Code:</b> {{option.label.countryCode}}</h6>
                            <h6><b>State:</b> {{option.label.state}}</h6>
                        </div>
                        <div class="col-md-6">
                            <h6><b>City:</b> {{option.label.city}}</h6>
                            <h6><b>Street:</b> {{option.label.line1}}</h6>
                            <h6><b>Additional info:</b> {{option.label.line2}}</h6>
                            <h6><b>Postal Code:</b> {{option.label.postalCode}}</h6>
                            <b v-if="option.value.default" class="ml-2 text-uppercase">default</b>
                        </div>
                    </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                    {{getString(option)}}
                </template>
            </v-select>
        </b-col>
        <b-col v-else>Please create a shipping address first that all next features will be available.</b-col>
        <b-col md="2">
            <b-btn variant="primary-user"
                   size="sm"
                   v-if="selected"
                   :disabled="disabled"
                   @click="openModal(true)">Edit</b-btn>
            <b-btn variant="primary-user"
                   class="ml-2"
                   size="sm"
                   :disabled="disabled"
                   @click="openModal(false)">Add new</b-btn>
        </b-col>
        <addresses-modal :editMode="editMode"
                         :address="generateProps"
                         :set-default="options.length < 1"
                         @updatedAddresses="getAddresses"/>
    </b-row>
</template>

<script>
    import AddressesModal from '~cp/UserPanel/Modals/AddressesModal'
    export default {
        name: 'AddressSettings',
        components: {
            AddressesModal
        },
        data() {
            return {
                selected: null,
                options: [],
                editMode: false
            }
        },
        props: {
            label: {
                type: String,
                required: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.getAddresses()
        },
        computed: {
            generateProps() {
                if (this.editMode && this.selected) {
                    return this.selected.value
                }
            }
        },
        methods: {
            getAddresses() {
                this.$store.dispatch('getUserAddresses').then(response => {
                    if (response.length > 0) {
                        this.options = response.map(item => ({
                            label: this.getLabel(item),
                            value: item
                        })).sort(x => x.value.default ? -1 : 1)
                        this.selected = this.options[0]
                        this.$emit('getDefaultAddress', this.selected)
                    } else {
                        this.openModal(false)
                    }
                })
            },
            getString(data) {
                let obj = {...data.label}
                return Object.values(obj).filter(i => (i !== null && i !== '')).join(', ')
            },
            getLabel(data) {
                let tmp = {
                    ...data,
                    country: {...data.country}
                }
                delete tmp.id
                delete tmp.default
                if (tmp.country.nameEn) {
                    tmp.country = data.country.nameEn
                } else {
                    // TODO: need for old addresses
                    tmp.country = null
                }
                if (tmp.company.name) {
                    tmp.company = data.company.name
                } else {
                    delete tmp.company
                }
                return {...tmp}
            },
            openModal(value) {
                this.editMode = value
                this.$root.$emit('bv::show::modal', 'addressesModal')
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/style/utils/_variables.scss";
    .address-settings {
        label {
            font-size: 16px;
            font-weight: bold;
        };

        .vs__selected-options {
            width: 100%;

            .selected-tag {
                white-space: nowrap;
                text-overflow: ellipsis;
                display: block;
                line-height: 31px;
            }
        }

        .unsearchable input[type=search] {
            position: absolute;
        }
        .v-select {
            margin-bottom: 0;
            font-size: 14px;
            height: 31px;
            .vs__dropdown-option--highlight {
                background: rgba(88, 151, 251, 0.17);
                color: black;
            }
            li {
                position: relative;
                & + li {
                    border-top: 1px solid rgba($text-default-color-user, 0.3);
                }
                .text-uppercase {
                    position: absolute;
                    top: 0;
                    right: 10px;
                }
                & > a {
                    display: block;
                    height: auto;
                    padding: 10px;
                    transition: .15s;
                    &:hover {
                        padding: 10px;
                        background-color: #fff;
                    }
                }
                h6 {
                    font-size: 15px;
                }
            }
            .dropdown-toggle {
                .selected-tag,
                input {
                    padding: 0 10px !important;
                    width: 100%;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/AddressSettings.vue